module.exports = __webpack_public_path__ + "img/rawpixel-id-646437-transparent-rotated.4dddc3a8.png";